module.exports = __webpack_public_path__ + "img/Vector_2.4d6b2a28.svg";